import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this.openClass = '-open';
        this.isOpen = false;
        this.buttonThatOpenedNav = null;
        document.addEventListener('mobile-nav-toggle:changed', this.toggle.bind(this));
    }

    disconnect() {
        document.removeEventListener('mobile-nav-toggle:changed', this.toggle.bind(this));
    }

    toggle(event) {
        this.isOpen = event?.detail?.isOpen || false;
        if (this.isOpen) {
            this.open();
            this.buttonThatOpenedNav = event?.detail?.button;
        } else {
            this.close();
        }
    }

    open() {
        this.element.classList.add(this.openClass);
        this.element.setAttribute('aria-hidden', 'false');
        this.element.removeAttribute('inert');

        // Get all focusable elements
        this.focusableElements = this.getFocusableElements();
        this.firstFocusable = this.focusableElements[0];
        this.lastFocusable = this.focusableElements[this.focusableElements.length - 1];

        // Focus first element
        requestAnimationFrame(() => {
            this.firstFocusable?.focus();
        });

        this.element.addEventListener('keydown', this.handleKeydown.bind(this));
        document.addEventListener('keydown', this.handleEscape.bind(this));
    }

    close() {
        this.element.classList.remove(this.openClass);
        this.element.setAttribute('aria-hidden', 'true');
        this.element.setAttribute('inert', '');

        requestAnimationFrame(() => {
            this.buttonThatOpenedNav?.focus();
        });

        this.dispatch('closed', {
            detail: { isOpen: false },
            bubbles: true,
        });

        this.element.removeEventListener('keydown', this.handleKeydown.bind(this));
        document.removeEventListener('keydown', this.handleEscape.bind(this));

        this.isOpen = false;
    }

    handleKeydown(event) {
        if (event.key !== 'Tab') {
            return;
        }

        // Trap focus within menu
        if (event.shiftKey) {
            // Shift + Tab
            if (document.activeElement === this.firstFocusable) {
                event.preventDefault();
                this.lastFocusable?.focus();
            }
        } else {
            // Tab
            if (document.activeElement === this.lastFocusable) {
                event.preventDefault();
                this.firstFocusable?.focus();
            }
        }
    }

    handleEscape(event) {
        if (event.key === 'Escape' && this.isOpen) {
            this.close();
        }
    }

    getFocusableElements() {
        const focusableElements = [
            'a[href]',
            'area[href]',
            'input',
            'select',
            'textarea',
            'button',
            '[tabindex]:not([tabindex="-1"])',
            'iframe',
            'object',
            'embed',
        ];
        return Array.from(this.element.querySelectorAll(focusableElements.join(', ')))
            .filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);
    }
}
